const __WEBPACK_NAMESPACE_OBJECT__ = {"apiUrl":"","imageapiUrl":"","publicPath":"/"};